import '../sass/index.scss';
import CookieConsentWordpress from './classes/CookieConsentWordpress';
import SliderDefaultSetup from './classes/SliderDefaultSetup';
import FoldContent from './classes/FoldContent';
import Menu from './classes/Menu';
import PropertiesTabs from './classes/PropertiesTabs';
import DownloadSectionTabs from './classes/DownloadSectionTabs';
import PostSlider from './classes/PostSlider';
import Contact from './classes/Contact';
import GoogleMap from './classes/GoogleMap';
import InfiniteScroller from './classes/InfiniteScroller';
import DownloadsFilter from './classes/DownloadsFilter';
import CustomDropdown from './classes/CustomDropdown';

window.addEventListener('load', () => {
  new CookieConsentWordpress();
  new SliderDefaultSetup();
  new FoldContent();
  new Menu();
  new PropertiesTabs();
  new DownloadSectionTabs();

  new PostSlider();
  new Contact();
  new GoogleMap();
  new InfiniteScroller();
  new DownloadsFilter();

  new CustomDropdown();
});
